// extracted by mini-css-extract-plugin
export default {"main":"FormaPagoSelector_main__4n+IA"};